<script lang="ts">
  import Banner from '@athena-lib/Banner/Banner.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { Text } from '@athena-lib/Text';
  import { Error, Check } from '@athena-lib/Icons';

  type Props = {
    errors?: string[];
    messages?: string[];
  };

  const { errors, messages }: Props = $props();
  const translations = getCommonTranslations();

  const bannerProps = $derived.by(() => {
    if ((errors?.length ?? 0) > 0) {
      return {
        variant: 'error',
        title: translations.notificationErrorTitle,
        Icon: Error,
        notifications: errors,
      } as const;
    }

    if ((messages?.length ?? 0) > 0) {
      return {
        variant: 'success',
        title: translations.success,
        Icon: Check,
        notifications: messages,
      } as const;
    }

    return undefined;
  });
</script>

<div class="my-6">
  {#if bannerProps}
    {@const { variant, title, Icon, notifications = [] } = bannerProps}
    <Banner {variant} {title}>
      {#snippet icon()}
        <Icon sizeClass="size-6" />
      {/snippet}
      {#snippet content(_variant, textColor)}
        <ul>
          {#each notifications as notification}
            <li>
              <Text element="span" color={textColor}>{@html notification}</Text>
            </li>
          {/each}
        </ul>
      {/snippet}
    </Banner>
  {/if}
</div>
